import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a First name' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a Last name' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'required', message: 'Please provide a Phone Number' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an Email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    reference: {
      validations: [{ type: 'required', message: 'Please provide a reference' },
    ]
  },
  operation: {
    validations: [
      { type: 'required', message: 'Please select a Preferred Location' },
    ]
    },
    theme: {
      validations: [{ type: 'required', message: 'Please provide a theme' },
      ]
    },
    eventDate: {
      validations: [
        { type: 'required', message: 'Please select a date for your Event' },
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    starttime: {
      validations: [{ type: 'required', message: 'Please provide an Preferred Start Time' },
    ]
  },
  plannedguestcount: {
    validations: [
      { type: 'required', message: 'Please enter the number of Estimated Number of Guests' }
    ]
  },
  notes: {
    validations: []
  }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Event Information:',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name *',
            mapping: 'firstName'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name *',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number *',
            mapping: 'telNumber'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email *',
            mapping: 'email'
          },
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Reference*',
            options: [
              { label: 'Call in'  , value: 'Call in'},
              { label: 'Chamber/City Center/Discover Saratoga'  , value: 'Chamber/City Center/Discover Saratoga'},
              { label: 'Google/Social Media'  , value: 'Google/Social Media'},
              { label: 'Hotel Referral'  , value: 'Hotel Referral'},
              { label: 'Local Business Referral'  , value: 'Local Business Referral'},
              { label: 'Marketing Email'  , value: 'Marketing Email'},
              { label: 'Referral from a family friend'  , value: 'Referral from a family friend'},
              { label: 'Repeat Guest'  , value: 'Repeat Guest'},
              { label: 'Pharma Rep/Third Party'  , value: 'Pharma Rep/Third Party'},
              { label: 'Event Planner'  , value: 'Event Planner'},
              { label: 'Wedding Planner Referral'  , value: 'Wedding Planner Referral'},
              { label: 'Other'  , value: 'Other'},
            ],
            mapping: 'reference'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'XLarge',
            label: 'Preferred Location *',
            options: [
              { label: 'Boca Bistro'  , value: 'Boca Bistro'},
              { label: 'Forno Bistro'  , value: 'Forno Bistro'},
              { label: 'Chianti il Ristorante'  , value: 'Chianti il Ristorante'},
          ],
            mapping: 'operation'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'XLarge',
            label: 'Event Theme *',
            options: [
              { label: 'Baby Shower'  , value: 'Baby Shower'},
              { label: 'Bachelor/Bachelorette'  , value: 'Bachelor/Bachelorette'},
              { label: 'Bridal Shower'  , value: 'Bridal Shower'},
              { label: 'Business Entertainment'  , value: 'Business Entertainment'},
              { label: 'Corporate Event'  , value: 'Corporate Event'},
              { label: 'Cooking Class'  , value: 'Cooking Class'},
              { label: 'Charity Benefit'  , value: 'Charity Benefit'},
              { label: 'Graduation'  , value: 'Graduation'},
              { label: 'Reunion'  , value: 'Reunion'},
              { label: 'Engagement Party'  , value: 'Engagement Party'},
              { label: 'Pharmaceutical'  , value: 'Pharmaceutical'},
              { label: 'Other'  , value: 'Other'},
            ],
            mapping: 'theme'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date *',
            mapping: 'eventDate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Preferred Start Time *',
            options: [
              { label: '11:00 AM' , value: '11:00:00'},
              { label: '11:30 AM' , value: '11:30:00'},
              { label: '12:00 PM' , value: '12:00:00'},
              { label: '12:30 PM' , value: '12:30:00'},
              { label: '1:00 PM'  , value: '13:00:00'},
              { label: '1:30 PM'  , value: '13:30:00'},
              { label: '2:00 PM'  , value: '14:00:00'},
              { label: '2:30 PM'  , value: '14:30:00'},
              { label: '3:00 PM'  , value: '15:00:00'},
              { label: '3:30 PM'  , value: '15:30:00'},
              { label: '4:00 PM'  , value: '16:00:00'},
              { label: '4:30 PM'  , value: '16:30:00'},
              { label: '5:00 PM'  , value: '17:00:00'},
              { label: '5:30 PM'  , value: '17:30:00'},
              { label: '6:00 PM'  , value: '18:00:00'},
              { label: '6:30 PM'  , value: '18:30:00'},
              { label: '7:00 PM'  , value: '19:00:00'},
              { label: '7:30 PM'  , value: '19:30:00'},
              { label: '8:00 PM'  , value: '20:00:00'},
            ],
            mapping: 'starttime'
          }
        ]
      },
          {
            fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Estimated Number of Guests *',
            mapping: 'plannedguestcount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'XLarge',
            label: 'Additional Comments',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SEND'
          }
        ]
      }
    ]
  },
  info: {
    title: 'DZ Restaurants Contact Form',
    formId: '761',
    clientKey: '8A12B3C7-B4B0-4CAA-9D22-EEE7B5C20881',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you for submitting your inquiry! A member of our Sales Team will reach out shortly. If you have a time sensitive question or concern, please do not hesitate to call our office at 518-583-1142.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/client_forms/dzrestaurants/form_structure.js